import { z } from "zod";
import { ANNOUNCEMENT_SEVERITIES } from "./content.js";
import { isHttpsUrl, PUBLIC_ALLOWED_CTA_URLS_MAX } from "./cta.js";
import { isSponsoredCreativeImagePath } from "./image-upload.js";
import { publicResellerSchema } from "./reseller.js";
export const plainTextField = (max) => z
    .string()
    .max(max)
    .refine((v) => !/<[^>]+>/.test(v), "HTML not allowed")
    .refine((v) => !/javascript:/i.test(v), "JavaScript URLs not allowed")
    .refine((v) => !/on\w+\s*=/i.test(v), "Event handlers not allowed");
export const utcDateTimeSchema = z
    .string()
    .datetime({ offset: true })
    .or(z.string().datetime())
    .nullable()
    .optional();
export const publicAnnouncementSchema = z.object({
    type: z.enum(ANNOUNCEMENT_SEVERITIES),
    title: plainTextField(120),
    body: plainTextField(500),
    dismissible: z.boolean(),
    startsAt: z.string().datetime().nullable(),
    endsAt: z.string().datetime().nullable(),
});
export const publicPromotionSchema = z.object({
    title: plainTextField(120),
    body: plainTextField(500),
    badge: plainTextField(40),
    ctaLabel: plainTextField(60),
    ctaHref: z.string().url().nullable(),
    imagePath: z.string().nullable(),
    imageAlt: plainTextField(120),
    startsAt: z.string().datetime().nullable(),
    endsAt: z.string().datetime().nullable(),
});
/** Additive C7B public field. Never includes campaign/advertiser/org ids or notes. */
export const publicSponsoredSchema = z.object({
    advertiserName: plainTextField(80),
    sponsorshipLabel: plainTextField(40),
    headline: plainTextField(80),
    description: plainTextField(160),
    offerText: plainTextField(40).nullable(),
    imagePath: z
        .string()
        .min(1)
        .refine((v) => !v.includes("..") && /\.(jpg|jpeg|png|webp)$/i.test(v), "Invalid image path"),
    imageAlt: plainTextField(120),
    ctaLabel: plainTextField(60),
    ctaHref: z.string().url().refine((v) => isHttpsUrl(v), "HTTPS only"),
    startsAt: z.string().datetime(),
    endsAt: z.string().datetime(),
});
export function isPublicSponsoredImagePath(path, organizationId) {
    return isSponsoredCreativeImagePath(path, organizationId);
}
const publicAllowedCtaUrlSchema = z
    .string()
    .url()
    .refine((v) => isHttpsUrl(v), "HTTPS only");
export const publicAllowedCtaUrlsSchema = z
    .array(publicAllowedCtaUrlSchema)
    .max(PUBLIC_ALLOWED_CTA_URLS_MAX);
export const publicPortalContentSchema = z.object({
    schemaVersion: z.literal(1),
    publishedAt: z.string().datetime(),
    site: z.string(),
    allowedCtaUrls: publicAllowedCtaUrlsSchema,
    announcement: publicAnnouncementSchema.nullable(),
    promotion: publicPromotionSchema.nullable(),
    /** Optional published reseller branding; null when unassigned/unpublished/invalid. */
    reseller: publicResellerSchema.nullable(),
    /**
     * Additive C7B. Default null so schemaVersion 1 envelopes without the field still parse.
     * rc.20 ignores unknown JSON; old portals keep working when this field is present.
     */
    sponsored: publicSponsoredSchema.nullable().optional().default(null),
});
//# sourceMappingURL=public-api.js.map